/**
 * List Projects Handler
 * 
 * CQRS Query Handler that delegates to ProjectQueryService.
 * Thin adapter layer for read operations.
 */

import { injectable, inject } from 'inversify';
import { DDD_SYMBOLS } from '../../../../infrastructure/di/DDD_SYMBOLS';
import { IQueryHandler, IPaginatedResult } from '@swoft/core';
import { ListProjectsQuery, ProjectDto } from '../queries/GetProjectQuery';
import { ProjectQueryService } from '../services/ProjectQueryService';

@injectable()
export class ListProjectsHandler implements IQueryHandler<ListProjectsQuery, IPaginatedResult<ProjectDto>> {
  constructor(
    @inject(DDD_SYMBOLS.ProjectQueryService) private projectQueryService: ProjectQueryService
  ) {}

  async handle(query: ListProjectsQuery): Promise<IPaginatedResult<ProjectDto>> {
    return await this.projectQueryService.listProjects(query.params);
  }
}